import React, { useState } from 'react';
import Select, { components as selectComponents } from 'react-select';
import { useSelector } from 'react-redux';
import { MultipleValuesContainer as MultiValue } from './MultiValueComponent';
import './select.scss';
import { selectStyles } from './selectStyles';

const AutoSuggestionSelectComponent = (props) => {
  const themeColors = useSelector((state) => state.theme.themeValuesObject);
  const {
    inputClassName,
    components,
    id,
    fieldTouch,
    showLabel,
    ...otherProps
  } = props;
  const [selectClassName, setSelectClassName] = useState('');
  const customStyles = selectStyles({ themeColors });

  const Input = (props) => (
    <selectComponents.Input
      {...props}
      id={id}
      maxLength={50}
      autoFocus={selectClassName && true}
    />
  );
  const defaultComponents = { MultiValue, Input, MultiValueRemove: () => null };
  return (
    <>
      {props.id && props.labelText && (
        <label
          className={showLabel ? '' : 'sr-only'}
          htmlFor={props.id && props.id}
        >
          {props.labelText && props.labelText}
        </label>
      )}
      <Select
        {...otherProps}
        styles={customStyles}
        className={`generic-select ${inputClassName || ''} ${selectClassName}`}
        onFocus={() => setSelectClassName('select-focus-border')}
        onBlur={() => {
          setSelectClassName('');
          fieldTouch && fieldTouch(otherProps.name);
        }}
        components={
          components
            ? { ...defaultComponents, ...components }
            : defaultComponents
        }
        isClearable={props.isMulti}
        hideSelectedOptions={false}
        classNamePrefix={'generic-select-prefix'}
        isMenuOpen={true}
        id={props.id && props.id}
        role="listbox"
        aria-label={props.labelText && props.labelText}
      />
    </>
  );
};

export default AutoSuggestionSelectComponent;
